// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"c09d5c71","955":"4e13e508"}[chunkId] + ".chunk.css";
};